module.exports = __webpack_public_path__ + "img/exclusive_v2.8ecb2a6.png";